@if (showGraph()) {
<div class="ui-graph" [class.dark]="theme() === 'dark'">
	<ngx-charts-line-chart
		hotfix-zero-margin
		[scheme]="colorsDomain()"
		[results]="multiSeries()"
		[legend]="showLegend()"
		[xAxisLabel]="xAxisLabel()"
		[yAxisLabel]="yAxisLabel()"
		[xAxis]="true"
		[yAxis]="true"
		[showXAxisLabel]="showAxisLabels()"
		[showYAxisLabel]="showAxisLabels()"
		[legendPosition]="legendPositionCalculated()"
		[tooltipDisabled]="tooltipDisabled"
	>
	</ngx-charts-line-chart>
</div>
} @else {
<lib-message [type]="'noData'">Insufficient data to display graph</lib-message>
}
